import{__assign as r,__spreadArray as o}from"tslib";var t=function(t){for(var i=[],n=1;n<arguments.length;n++)i[n-1]=arguments[n];return r.apply(void 0,o([t],i,!1))};export{t as objectAssign};
//# sourceMappingURL=objectAssign.js.map
